"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppContainer = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRouter = require("react-router");

var _reactHotLoader = require("react-hot-loader");

var _reactRedux = require("react-redux");

var _styledComponents = require("styled-components");

var _blocks = require("@bueno/blocks");

var _Page = require("../../components/Layout/Page");

var _AppChrome = _interopRequireDefault(require("../../components/AppChrome"));

var authActions = _interopRequireWildcard(require("../../redux/modules/auth/actionCreators"));

var _eventTracking = require("../../utils/eventTracking");

var _locale = require("../../context/locale");

var _core = require("@lingui/core");

function mapStateToProps(state) {
  return {
    appReady: state.appSetup.appSetupComplete,
    user: state.auth.user
  };
}

const GlobalStyle = (0, _styledComponents.createGlobalStyle)``;

const AppCon = ({
  user,
  appReady,
  children,
  location
}) => {
  // Vendor style imports that should be globally available
  require('react-select/dist/react-select.min.css');

  const {
    locale
  } = (0, _locale.useLocale)();
  /**
   * this is listening to the locale change
   */

  React.useEffect(() => {
    _core.i18n.activate(locale);

    if (window.zE != null) {
      window.zE('webWidget', 'setLocale', locale);
    }
  }, [locale]);
  React.useEffect(() => {
    if (appReady && user && user.username) {
      (0, _eventTracking.routeChangeEvent)({
        search: location.search,
        pathname: location.pathname
      });
    }
  }, [location.pathname, appReady]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_blocks.Reset, null), /*#__PURE__*/React.createElement(GlobalStyle, null), /*#__PURE__*/React.createElement(_Page.Page, null, /*#__PURE__*/React.createElement(_AppChrome.default, {
    user: user,
    appReady: appReady
  }), /*#__PURE__*/React.createElement(_Page.Container, null, children)));
};

const AppContainer = (0, _reactHotLoader.hot)(module)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, { ...authActions
})(AppCon)));
exports.AppContainer = AppContainer;